import {Record as record, Map} from 'immutable';

const Breakpoints = {
    xs: 768,
    sm: 992,
    md: 1200,
    lg: 1600
};

const Devices = {
    mobile: 'mobile', // xs
    tablet: 'tablet', // sm + md
    desktop: 'desktop' // lg + xl
};

const DeviceSizes = {
    xs: 'xs', // 0 - 767
    sm: 'sm', // 768 - 991
    md: 'md', // 992 - 1199
    lg: 'lg', // 1200 - 1599
    xl: 'xl' // >= 1600
};

const SystemStateRecord = record(
    {
        userAgent: '',
        referer: '',
        width: 0,
        height: 0,
        siteName: 'homeaway_us',
        brandId: 121,
        baseUrlPath: '',
        browserName: '',
        routerHistoryIndex: 0,
        locale: 'en_US_HA',
        languageNativeName: 'English',
        languageName: 'English',
        displayLocale: 'en_US', // Used to power the X-HomeAway-DisplayLocale header
        currency: 'USD',
        theme: 'gt',
        travelerAppBrand: 'homeaway',
        hasVGDCParam: false,
        bathroomStrategy: 'US',
        environment: '',
        devTools: false,
        device: Devices.desktop,
        deviceSize: DeviceSizes.lg,
        hostName: 'www.homeaway.com',
        humanReadableSiteName: 'HomeAway.com',
        isDesktop: true,
        isMobile: false,
        isMobileUserAgent: false,
        isTablet: false,
        clientSideRendered: false,
        yPosition: 0,
        stickyMap: new Map(),
        requestMarker: '',
        isInternalUser: false,
        cookies: {
            'ha-state-prst': {},
            'ha-trip-prst': {}
        },
        useMockLogin: false,
        useMockData: false,
        useListingPageLite: false,
        queryParamsOnEntry: {},
        reviewPageSize: 6,
        webpackPublicPath: '',
        // When tests are determined to be bucketed in on the server side,
        // push their name here.  This will be re-evaluated on the client, so it can be logged.
        serverSideTestBuckets: ['ha_pdp_mweb_perf_insights']
    },
    'SystemStateRecord'
);

export default SystemStateRecord;
export {SystemStateRecord, Breakpoints, Devices, DeviceSizes};
